import { render, staticRenderFns } from "./MedPackageImage.vue?vue&type=template&id=58df6eed&scoped=true&"
import script from "./MedPackageImage.vue?vue&type=script&lang=js&"
export * from "./MedPackageImage.vue?vue&type=script&lang=js&"
import style0 from "./MedPackageImage.vue?vue&type=style&index=0&id=58df6eed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df6eed",
  null
  
)

export default component.exports